module.exports = __webpack_public_path__ + "d2f3d7c9f442f627f42088f9335b0976.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/policy/picmobile4.png
// module id = 1887
// module chunks = 0